<template>
  <span class="sd-icon">{{ name }}</span>
</template>

<script>
import "@smartdesign/iconfont/dist/smartdesign-icons.css";
export default {
  props: {
    name: {
      required: false,
      type: String,
      default: undefined,
    },
  },
};
</script>
